import { defineSchema } from '../../schema-meta.ts';
import { registerSchema } from '../../generic-codec.ts';

/**
 * Wave-scoped enemy spawn entry. Base enemy stats (`score`, `health`, `atk`,
 * `speed`) live in the `serverEnemies` catalogue; this row carries only the
 * wave-specific tuning the worker needs to enforce kill/time feasibility:
 *
 *   - `spawnInterval` (ms) — minimum gap between successive spawns of this
 *     enemy. With `timeoutSeconds` from the wave header, this caps the
 *     maximum number of kills the player could legitimately rack up.
 *   - `spawnPattern` — opaque jsonb describing the spawn schedule. Server
 *     stores it verbatim; worker parses it when computing the bottleneck.
 *   - `healthMultiplier` / `speedMultiplier` / `atkMultiplier` — applied on
 *     top of the catalogue base to get the effective per-wave stat used by
 *     damage feasibility math.
 */
export const StageWaveEnemySchema = defineSchema({
  name: 'stageWaveEnemy',
  fields: [
    ['id', 'number'],
    ['count', 'number'],
    ['spawnInterval', 'number?'],
    ['spawnPattern', { kind: 'json' }],
    ['healthMultiplier', 'number?'],
    ['speedMultiplier', 'number?'],
    ['atkMultiplier', 'number?'],
  ],
});

registerSchema(StageWaveEnemySchema);
